module.exports = __webpack_public_path__ + "static/grass-f77291b193d7c6a388aba95cdd0e63af.mp4";